/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  InvalidateQueryFilters,
  QueryClient,
  useQuery,
  UseQueryResult,
  useSuspenseQuery,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  GetDomainRequest,
  GetDomainSecurity,
} from "../models/operations/getdomain.js";
import { useGramContext } from "./_context.js";
import {
  QueryHookOptions,
  SuspenseQueryHookOptions,
  TupleToPrefixes,
} from "./_types.js";
import {
  buildGetDomainQuery,
  GetDomainQueryData,
  prefetchGetDomain,
  queryKeyGetDomain,
} from "./getDomain.core.js";
export {
  buildGetDomainQuery,
  type GetDomainQueryData,
  prefetchGetDomain,
  queryKeyGetDomain,
};

export type GetDomainQueryError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * getDomain domains
 *
 * @remarks
 * Get the custom domain for an organization
 */
export function useGetDomain(
  request?: GetDomainRequest | undefined,
  security?: GetDomainSecurity | undefined,
  options?: QueryHookOptions<GetDomainQueryData, GetDomainQueryError>,
): UseQueryResult<GetDomainQueryData, GetDomainQueryError> {
  const client = useGramContext();
  return useQuery({
    ...buildGetDomainQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

/**
 * getDomain domains
 *
 * @remarks
 * Get the custom domain for an organization
 */
export function useGetDomainSuspense(
  request?: GetDomainRequest | undefined,
  security?: GetDomainSecurity | undefined,
  options?: SuspenseQueryHookOptions<GetDomainQueryData, GetDomainQueryError>,
): UseSuspenseQueryResult<GetDomainQueryData, GetDomainQueryError> {
  const client = useGramContext();
  return useSuspenseQuery({
    ...buildGetDomainQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

export function setGetDomainData(
  client: QueryClient,
  queryKeyBase: [parameters: { gramSession?: string | undefined }],
  data: GetDomainQueryData,
): GetDomainQueryData | undefined {
  const key = queryKeyGetDomain(...queryKeyBase);

  return client.setQueryData<GetDomainQueryData>(key, data);
}

export function invalidateGetDomain(
  client: QueryClient,
  queryKeyBase: TupleToPrefixes<
    [parameters: { gramSession?: string | undefined }]
  >,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "domains", "getDomain", ...queryKeyBase],
  });
}

export function invalidateAllGetDomain(
  client: QueryClient,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "domains", "getDomain"],
  });
}
